(function($, duo, undefined) {

	"use strict";

	// classes:
	const GDPR_VISIBLE_CLASS = 'js-gdpr-visible';

	/**
	 * @class NewsletterBlock
	 */
	class NewsletterBlock {

		/**
		 * Creates an instance of NewsletterBlock
		 * @param {string} newsletterBlockSelector css selector for the NewsletterBlock element
		 */
		constructor({newsletterBlockSelector = '.newsletter-block'} = {}) {
			this.newsletterBlockSelector = newsletterBlockSelector;
			this.element = $(newsletterBlockSelector);

			// setup:
			this.setup();
		} /* constructor */

		/**
		 * Setup the NewsletterBlock
		 */
		setup() {
			// setup markup:
			this._setupMarkup();
			// setup event handlers:
			this._setEventHandlers();

			// add js-processed class to the container:
			$(this.newsletterBlockSelector).addClass('js-newsletterblock-processed');
		} /* setup */

		/**
		 * Setup the markup
		 */
		_setupMarkup() {

			/* copy the gdpr-notice and put it after the fancy button: */

			const $newsletterBlocks = $(document).find(this.newsletterBlockSelector);
			$newsletterBlocks.each(function(index, element) {
				const $newsletterBlock = $(element);

				const $fancyButton = $newsletterBlock.find('.fancy-button');
				const $gdprNotice = $newsletterBlock.find('.newsletter-gdpr-notice__inner');
				const gdprText = $gdprNotice.html();

				let extraGdprBlock = $(`<div class="newsletter-extra-gdpr-notice"><div class="newsletter-extra-gdpr-notice__inner">${gdprText}</div></div>`);
				$fancyButton.after(extraGdprBlock);

			});

		} /* _setupMarkup */

		/**
		 * Attach event listeners
		 */
		_setEventHandlers() {
			const $newsletterBlocks = $(document).find(this.newsletterBlockSelector);
			$newsletterBlocks.each(function(index, element) {
				const $newsletterBlock = $(element);

				// mouse events:
				$newsletterBlock.on('mouseenter', function() {
					$newsletterBlock.addClass(GDPR_VISIBLE_CLASS);
				});
				$newsletterBlock.on('mouseleave', function() {
					$newsletterBlock.removeClass(GDPR_VISIBLE_CLASS);
				});

				// keyboard events:
				$newsletterBlock.find('input, a, button').on('focus', function() {
					$newsletterBlock.addClass(GDPR_VISIBLE_CLASS);
				});
				$newsletterBlock.find('input, a, button').on('blur', function() {
					$newsletterBlock.removeClass(GDPR_VISIBLE_CLASS);
				});

			});
		} /* _setupMarkup */
	} /* NewsletterBlock */

	duo.NewsletterBlock = NewsletterBlock;

})(jQuery, window.duo = window.duo || {});
